export const DEFAULT_PER_PAGE = 50;
export const DEFAULT_PAGE = 1;
